import { Dropdown } from "./DropdownComponent";
import { DropdownTrigger, useDropdown } from "./DropdownTrigger";

Dropdown.Trigger = DropdownTrigger;

export { Dropdown, useDropdown };
